import React, { useState, useEffect } from "react"
import { Button, Col, Form, Row, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import Modal from "antd/es/modal/Modal"
import Navbar from "../../../../Components/Navbar/Navbar"
import HighlightOffIcon from "@mui/icons-material/HighlightOff"
import trash from "./../../../../Assets/Images/trash.png"
import Select from "react-select"
import { Select as SearchBox } from "antd"
import "./../PurchaseOrders.css"
import {
  createSupplier,
  searchSupplier,
} from "../../../../Helpers/apiCalls/suppliersApi"
import {
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
  getTodayDateISOFormat,
  getTodayDateISO,
  getUser,
  formatDate,
  antdesignSelectStyle,
  numberWithCommas,
} from "../../../../Helpers/Utils/Common"
import { getAllEmployees } from "../../../../Helpers/apiCalls/employeesApi"
import {
  deletePoAttachment,
  getPurchaseOrder,
  updatePurchaseOrder,
} from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import { getAllItems, searchItem } from "../../../../Helpers/apiCalls/itemsApi"
import toast from "react-hot-toast"
import AddModal from "../../../../Components/Modals/AddModal"
import { getAllForwarders } from "../../../../Helpers/apiCalls/forwardersApi"
import { getAllBranches } from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import { getItems } from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import {
  validateAddPO,
  validateEditPO,
} from "../../../../Helpers/Validation/Purchase/PurchaseOrderValidation"
import InputError from "../../../../Components/InputError/InputError"
import { validateSuppliers } from "../../../../Helpers/Validation/Manage/SuppliersValidation"
import upload from "../../../../Assets/Images/upload.png"
import Upload from "antd/es/upload/Upload"
import { createItem, editItem } from "../../../../Helpers/apiCalls/itemsApi"
import { Typeahead } from "react-bootstrap-typeahead"
import {
  getCategory,
  getSubcategory,
} from "../../../../Helpers/apiCalls/categoryApi"
import { getBrand } from "../../../../Helpers/apiCalls/brandsApi"
import {
  validateItems,
  validatePurchaseItems,
} from "../../../../Helpers/Validation/Manage/ItemsValidation"
import equal from "../../../../Assets/Images/equal.png"
import Compressor from "compressorjs"
import FileExceedModal from "../../../../Components/Modals/FileExceedModal"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import Footer from "../../../../Components/Footer/Footer"
import AttachmentModal from "../../../../Components/AttachmentModal/AttachmentModal"

export default function EditPurchaseOrder() {
  const { Dragger } = Upload
  const { id, type, shopType } = useParams()
  let navigate = useNavigate()
  const poID = id

  const [inactive, setInactive] = useState(true)
  const [editPO, setEditPO] = useState({})
  const [items, setItems] = useState([
    {
      id: "",
      ingredient_id: "",
      qty: 1,
      unit: "",
      price: 0,
      discount_percentage: 0,
      discount_amount: 0,
      amount: 0,
    },
    {
      id: "",
      ingredient_id: "",
      qty: 1,
      unit: "",
      price: 0,
      discount_percentage: 0,
      discount_amount: 0,
      amount: 0,
    },
    {
      id: "",
      ingredient_id: "",
      qty: 1,
      unit: "",
      price: 0,
      discount_percentage: 0,
      discount_amount: 0,
      amount: 0,
    },
  ])
  const [branchList, setBranchList] = useState([])
  const [itemsList, setItemsList] = useState([])
  const [itemsOptions, setItemsOptions] = useState([])
  const [filteredItemOptions, setFilteredItemOptions] = useState([])
  const [employees, setEmployees] = useState([])
  const [isChanged, setIsChanged] = useState(false)
  const today = getTodayDateISO()
  const [fileList, setFileList] = useState([])
  const [isClicked, setIsClicked] = useState(false)
  const [categories, setCategories] = useState([])
  const [filteredSubCategories, setFilteredSubCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [brand, setBrand] = useState([])
  const [showFileExceedModal, setShowFileExceedModal] = useState(false)
  const [prevAttachments, setPrevAttachments] = useState([])
  const [previewFile, setPreviewFile] = useState(null)
  const [itemError, setItemError] = useState({})
  const [preview, setPreview] = useState(false)
  const [itemDetails, setItemDetails] = useState({
    name: "",
    type: "",
    detail: "",
    added_by: getUser(),
    added_on: formatDate(),
    category: [{ value: "" }],
    category_options: [{ value: "" }],
  })
  const [itemsUnits, setItemsUnits] = useState([
    {
      unit_from: "",
      value_from: "",
      unit_to: "",
      value_to: "",
      minimum: "",
      maximum: "",
      acceptable_variance: "",
    },
  ])
  // ADD ITEM MODAL
  const [showAddItemModal, setShowAddItemModal] = useState(false)
  const handleShowAddItemModal = () => setShowAddItemModal(true)
  const handleCloseAddItemModal = () => setShowAddItemModal(false)
  // ADD Conversion
  const [showAddConversionModal, setShowAddConversionModal] = useState(false)
  const handleShowAddConversionModal = () => setShowAddConversionModal(true)
  const handleCloseAddConversionModal = () => setShowAddConversionModal(false)

  /* Attachments Modal */
  const [startAt, setStartAt] = useState(0)
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false)
  const handleShowAttachmentsModal = () => setShowAttachmentsModal(true)
  const handleCloseAttachmentsModal = () => setShowAttachmentsModal(false)

  const [suppliersValue, setSuppliersValue] = useState({
    name: "supplier_id",
    label: "",
    value: "",
  })
  const [forwardersValue, setForwardersValue] = useState({
    name: "forwarder_id",
    label: "",
    value: "",
  })
  const [branchValue, setBranchValue] = useState({
    name: "branch_id",
    label: "",
    value: "",
  })

  // ADD
  const [supplierDetails, setSupplierDetails] = useState({
    trade_name: "",
    trade_address: "",
    bir_name: "",
    bir_address: "",
    tin: "",
    terms: "",
    requirements: "",
    phone_no: "",
    email: "",
    contact_person: "",
    bank_primary: "",
    bank_alternate: "",
    payee: "",
  })

  const [isError, setIsError] = useState({
    supplierName: false,
    purchase_date: false,
    delivery_date: false,
    requisitioner: false,
    delivery_address: false,
    price: false,
    description: false,
    branchId: false,
    qty: false,
  })
  //ADD ITEM ERROR HANDLING
  const [isErrorItem, setIsErrorItem] = useState({
    name: false,
    inhouse_barcode: false,
    category: false,
    sales_type: false,
  })

  const [showAddSupplierModal, setShowAddSupplierModal] = useState(false)
  const handleShowAddSupplierModal = () => setShowAddSupplierModal(true)
  const handleCloseAddSupplierModal = () => {
    setShowAddSupplierModal(false)
  }

  function handleAddItem() {
    // window.open("/items", "_blank");
    handleShowAddItemModal()
    fetchCategories()
    fetchBrands()
  }

  function handleAddSupplierClick() {
    window.open("/suppliers", "_blank")
  }

  async function handleSaveSupplier() {
    if (validateSuppliers(supplierDetails, setIsError)) {
      const response = await createSupplier(supplierDetails)
      if (response.response) {
        toast.success(response.response.response, {
          style: toastStyle(),
        })
        handleCloseAddSupplierModal()
        refreshPage()
      } else {
        TokenExpiry(response)
        toast.error("Error Creating New Supplier", {
          style: toastStyle(),
        })
      }
    }
  }

  async function deleteAttachment(selectedFile) {
    const response = await deletePoAttachment({
      purchase_id: poID,
      attachment_id: selectedFile.id,
    })
  }

  const handleRemove = (selectedFile) => {
    if (selectedFile.id) {
      deleteAttachment(selectedFile)
    }
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid
    })
    setFileList(newlist)
  }

  const handleBeforeUpload = (file) => {
    if (file.size > 2000000) {
      setShowFileExceedModal(true)
    } else {
      //COMPRESSING FILE
      new Compressor(file, {
        quality: 0.6,
        success: (compressedResult) => {
          setFileList([...fileList, compressedResult])
        },
      })
    }
    return false
  }

  function handleRemoveItemAttachment(index) {
    const updatedFileList = [...prevAttachments]
    updatedFileList.splice(index, 1)
    setPrevAttachments(updatedFileList)
  }

  // FUNCTION FETCH ITEM CATEGORIES
  // async function fetchCategories() {
  //   const response = await getCategory({});
  //   if (response.data) {
  //     //categories
  //     var categories = response.data.data.map((category) => {
  //       var info = {}
  //       info.name = "category"
  //       info.value = category.name
  //       info.label = category.name
  //       info.id = category.id
  //       info.selected_value_name = "selected_category"
  //       return info
  //     })
  //     setCategories(categories);
  //     //subcategories
  //     var subcategories = response.data.subcategories.map((category) => {
  //       var info = {}
  //       info.name = "subcategory"
  //       info.value = category.subname
  //       info.label = category.subname
  //       info.id = category.id
  //       info.category_id = category.category_id
  //       info.selected_value_name = "selected_subcategory"
  //       return info
  //     })
  //     setSubCategories(subcategories);
  //   }
  // }
  async function fetchCategories() {
    const response = await getCategory({})
    if (response.data) {
      //categories
      var categories = response.data.data.map((category) => {
        var info = {}
        info.name = "category"
        info.value = category.name
        info.label = category.name
        info.id = category.id
        info.selected_value_name = "selected_category"
        return info
      })
      setCategories(categories)
    }
  }
  console.log(prevAttachments)

  async function fetchSubcategories(id, categories, type, index) {
    setSubCategories([])
    const response = await getSubcategory(id)
    if (response.data) {
      //subcategories
      var subcategories = response.data.data.map((category) => {
        var info = {}
        info.name = "subcategory"
        info.value = category.name
        info.label = category.name
        info.id = category.id
        info.category_id = category.category_id
        info.selected_value_name = "selected_subcategory"
        return info
      })
      setSubCategories(subcategories)

      // to set categories and options
      const options = [...itemDetails.category_options] // Create a copy of the options array
      options[index + 1] = subcategories // Update the value at the specified index

      setItemDetails({
        ...itemDetails,
        ["category"]: [...categories, ""],
        ["category_options"]: [...options],
      })
    } else {
      //display error toast message if status code is 400
      response.error?.response?.data?.messages.map((data) => {
        // return toast.error(data);
        return toast.error(data, {
          style: toastStyle(),
        })
      })
    }
  }

  // FUNCTION FETCH ITEM BRAND
  async function fetchBrands() {
    const response = await getBrand({})
    if (response.data) {
      var brands = response.data.data.map((brand) => {
        var info = {}
        info.name = "brand"
        info.value = brand.name
        info.label = brand.name
        info.id = brand.id
        info.selected_value_name = "selected_brand"
        return info
      })
      setBrand(brands)
    }
  }

  // SELECT DROPDOWN CHANGE
  const handleSelectDropdownChange = (e, action, index) => {
    if (e.name === "category" || e.name === "subcategory") {
      // if category/subcategory ma save siya sud sa categories array
      var categories = [...itemDetails.category]
      // para if mo select siya ug another subcategory ma reset iya child
      if (
        categories[index]?.value ? categories[index]?.value !== e.value : false
      ) {
        categories.splice(index)
      }
      // para ma set ang value sa selected category
      categories[index] = { value: e.value, label: e.label }
      fetchSubcategories(e.id, categories, "add", index)
      setItemDetails({
        ...itemDetails,
        ["category"]: categories,
        // [e.name]: e.value,
        [`${e.name}_id`]: e.id,
        // [e.selected_value_name]: {
        //   label: e.label,
        //   value: e.value,
        // },
      })
    } else {
      setItemDetails({
        ...itemDetails,
        [e.name]: e.value,
        [`${e.name}_id`]: e.id,
        // [e.selected_value_name]: {
        //   label: e.label,
        //   value: e.value,
        // },
      })
    }
  }

  // Function to remove an input field
  const handleRemoveSubcategory = (index, type) => {
    var categories = []
    categories = itemDetails.category

    const newInputs = [...categories]
    newInputs.splice(index) // Remove the input at the specified index
    setItemDetails({
      // Update the state with the new array
      ...itemDetails,
      ["category"]: newInputs,
    })
  }

  // Create item onchange
  const handleAddChange = (e) => {
    const { name, value } = e.target

    setItemDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleTypeaheadChange = (e, labelKey) => {
    if (e[0] !== undefined) {
      if (e[0].customOption) {
        setItemDetails((prevState) => ({
          ...prevState,
          [labelKey]: e[0].value,
          [`${labelKey}_id`]: "",
          [`selected_${labelKey}`]: [e[0]],
        }))
      } else {
        setItemDetails((prevState) => ({
          ...prevState,
          [e[0].name]: e[0].value,
          [`${labelKey}_id`]: e[0].id,
          [`selected_${labelKey}`]: [e[0]],
        }))
      }
    } else if (e === undefined || e === null || e.length === 0) {
      setItemDetails((prevState) => ({
        ...prevState,
        [labelKey]: "",
        [`${labelKey}_id`]: "",
        [`selected_${labelKey}`]: [],
      }))
    }
  }

  // FUNCTION TO SAVE ITEM
  async function handleSaveItem() {
    // var hasUnits = itemsUnits.length > 0 ? true : false;
    if (validateItems(itemDetails, setIsErrorItem)) {
      setIsClicked(true)
      const response = await createItem(itemDetails, itemsUnits)
      if (response.response) {
        setItemDetails((prevState) => ({
          ...prevState,
          id: response.response.item_id,
        }))
        toast.success("Successfully created item!", {
          style: toastStyle(),
        })
        handleCloseAddItemModal()
        handleShowAddConversionModal()
        setIsClicked(false)
      } else {
        response.error?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setIsClicked(false)
    } else {
      toast.error("Please fill in all fields!", { style: toastStyle() })
    }
  }
  // FUNCTION TO SAVE ITEM CONVERSION
  async function handleAddConversion() {
    setIsClicked(true)

    const response = await editItem(itemDetails, itemsUnits)
    if (response.response) {
      setTimeout(() => {
        toast.success("Successfully added conversion!", {
          style: toastStyle(),
        })
        handleCloseAddConversionModal()
        setItemDetails({})
        setItemsUnits([])
        // fetchItems([])
      }, 1000)
    } else {
      toast.error("Error updating item!", {
        style: toastStyle(),
      })
    }
    setIsClicked(false)
  }

  async function fetchPO() {
    setEditPO({})
    setItems([])
    setPrevAttachments([])

    setIsChanged(true)

    const response = await getPurchaseOrder(poID)
    if (response.error) {
      TokenExpiry(response)
    } else {
      var PO = response.response.data[0]
      PO.purchase_date = getTodayDateISOFormat(PO.purchase_date)
      PO.delivery_date = getTodayDateISOFormat(PO.delivery_date)
      PO.requisitioner = {
        label: PO.requisitioner_name,
        value: PO.requisitioner,
      }
      PO.supplier_id = PO.supplier_id ? PO.supplier_id : ""
      PO.phone_no = PO.forwarder_contact_person
        ? PO.forwarder_contact_person
        : ""
      PO.supplier_id_value = {
        label: PO.supplier_trade_name,
        value: PO.supplier_id,
      }
      setEditPO(PO)

      // fetchItems(PO.branch_id);
      setSuppliersValue({
        name: "supplier_id",
        label: PO.supplier_trade_name
          ? PO.supplier_trade_name
          : PO.vendor_trade_name,
        value: PO.supplier_id ? PO.supplier_id : PO.vendor_id,
      })
      setForwardersValue({
        name: "forwarder_id",
        label: PO.forwarder_name,
        value: PO.forwarder_id,
      })

      setBranchValue({
        name: "branch_id",
        label: PO.branch_name,
        value: PO.branch_id,
      })

      var list = []

      PO.purchase_items.map((data) => {
        var obj = data
        obj.added_by = data.added_by
        obj.added_on = data.added_on
        obj.amount = data.amount
        obj.current_qty = data.current_qty
          ? data.current_qty
          : data.inventory_qty
        obj.id = data.id
        obj.inventory_qty = data.inventory_qty
        obj.is_deleted = data.is_deleted
        obj.item_id_value = {
          value: data.item_id,
          label: data.item_name,
          is_old_item: true, // para if old item siya, dili dropdown ang iyang unit so makita ra ang value
        }
        obj.value = data.item_id
        obj.item_name = data.item_name
        obj.prev_received_qty = data.prev_received_qty
        obj.price = data.price
        obj.purchase_id = data.purchase_id
        obj.qty = data.qty
        obj.received_qty = data.received_qty
        obj.status = data.status
        obj.unit = data.unit
        obj.updated_by = data.updated_by
        obj.updated_on = data.updated_on
        obj.remarks = data.remarks
        obj.discount_percentage = data.discount_percentage
          ? data.discount_percentage
          : 0
        obj.subtotal = data.subamount ? data.subamount : 0

        list.push(obj)
      })

      setItems(list)
      // fetchItems(list);
      setPrevAttachments(PO.purchase_attachments)
    }
    setTimeout(() => setIsChanged(false), 1)
  }
  const [suppliers, setSuppliers] = useState([])

  useEffect(() => {
    fetchPO()
    // fetchSuppliers();
    fetchForwarders()
    fetchBranches()
    fetchEmployees()
  }, [])

  useEffect(() => {
    if (showAddItemModal) {
      var subcat = subCategories.filter((data) => {
        return data.category_id === itemDetails?.category_id
      })
      setFilteredSubCategories(subcat)
    }
  }, [itemDetails.category])

  // useEffect(() => {
  //   fetchItems(branchValue.value);
  // }, [branchValue]);

  useEffect(() => {
    var tempServiceFee = editPO.service_fee ? parseFloat(editPO.service_fee) : 0

    var tempDiscount = editPO.discount ? parseFloat(editPO.discount) : 0

    var _subtotal = items
      .map((item) => parseFloat(item.amount))
      .reduce((a, b) => a + b, 0)

    var _grandTotal = _subtotal + tempServiceFee - tempDiscount
    setEditPO((prev) => {
      return {
        ...prev,
        subtotal: _subtotal.toFixed(2),
        grand_total: _grandTotal.toFixed(2),
      }
    })
  }, [isChanged])

  // for searching items
  const handleSearch = (newValue) => {
    if (newValue.length > 2) {
      handleFetchItems(newValue, setItemsOptions)
    }
  }

  // api to search items
  async function handleFetchItems(value, setItemsOptions) {
    setItemsOptions([])
    const response = await searchItem({ name: value })
    if (response.response) {
      var itemsList = response.response.data.map((data) => {
        var info = data
        info.label = data.name
        info.value = data.id

        return info
      })
      setItemsOptions(itemsList)
    } else {
      return toast.error(response.error?.data?.messages.message, {
        style: toastStyle(),
      })
    }
  }

  async function fetchItems(items) {
    setItemsOptions([])
    setItemsOptions([])
    const response = await searchItem({})
    if (response.response) {
      setItemsList(response.response.data)
      let result = response.response.data.map((a) => {
        return {
          label: a.name,
          value: a.id,
        }
      })
      setItemsOptions(result)
      if (items) {
        const filteredOptions = result.filter((option) => {
          return !items.find((item) => item.value === option.value)
        })
        setFilteredItemOptions(filteredOptions)
      } else {
        setFilteredItemOptions(result)
      }
    } else {
      TokenExpiry(response)
    }
  }

  async function fetchBranches() {
    const response = await getAllBranches()
    if (response.data) {
      var branches_list = response.data.data
      branches_list.map((branch) => {
        var info = {}
        if (branch.is_franchise === 3 || branch.is_franchise === "3") {
          info.name = "branch_id"
          info.label = branch.name
          info.value = branch.id
          info.address = branch.address

          setBranchList((prev) => [...prev, info])
        }
      })
    } else {
      TokenExpiry(response)
    }
  }

  const handleSearchSupplier = (newValue) => {
    if (newValue.length > 2) {
      //if length of the input is greater than 3, it will call the search api
      fetchSuppliers(newValue, setSuppliers)
    }
  }

  // new api for searching items
  async function fetchSuppliers(value, setSuppliers) {
    setSuppliers([])
    const response = await searchSupplier({ name: value })
    if (response.response) {
      var suppliers = response.response.data.map((data) => {
        var info = data
        info.label = data.trade_name
        info.value = data.id
        info.label = data.trade_name
        info.contact_person = data.contact_person
        info.phone_no = data.phone_no

        return info
      })
      setSuppliers(suppliers)
    } else {
      response.error?.data?.messages.map((data) => {
        return toast.error(data, {
          style: toastStyle(),
        })
      })
    }
  }

  /** Forwarders **/
  const [forwarders, setForwarders] = useState([])

  async function fetchForwarders() {
    setForwarders([])

    const response = await getAllForwarders()

    if (response.data) {
      response.data.data.map((forwarder) => {
        var info = {}

        info.name = "forwarder_id"
        info.label = forwarder.name
        info.value = forwarder.id
        info.contact_person = forwarder.contact_person
        info.phone_no = forwarder.phone_no

        setForwarders((prev) => [...prev, info])
      })
    } else {
      TokenExpiry(response)
    }
  }

  /** Employees */
  async function fetchEmployees() {
    setEmployees([])
    const response = await getAllEmployees()
    if (response.data) {
      let result = response.data.data.map((data) => {
        return {
          label: data.first_name + " " + data.last_name,
          value: data.id,
        }
      })
      setEmployees(result)
    } else {
      TokenExpiry(response)
    }
  }

  function handleSelectChange(e, type) {
    const newList = editPO
    newList[e.name] = e.value
    setEditPO(newList)
    if (type === "requisitioner") {
      setEditPO({
        ...editPO,
        requisitioner: { label: e.label, value: e.value },
      })
    } else if (type === "supplier_id") {
      var supplier_name = suppliers.filter((data) => {
        return data.value === e
      })
      setEditPO((prev) => {
        return {
          ...prev,
          supplier_id: e,
          contact_name: supplier_name[0].contact_person
            ? supplier_name[0].contact_person
            : editPO.contact_name,
          contact_no: supplier_name[0].phone_no
            ? supplier_name[0].phone_no
            : editPO.contact_no,
          supplier_id_value: {
            label: supplier_name[0].label,
            value: supplier_name[0].value,
          },
        }
      })
    } else if (e.name === "branch_id") {
      setBranchValue({ name: e.name, label: e.label, value: e.value })
      var address = branchList.filter((data) => data.value === e.value)[0]
        .address
      setEditPO({
        ...editPO,
        delivery_address: address !== null ? address : "",
        branch_id: e.value,
      })
    } else if (e.name === "forwarder_id") {
      setForwardersValue({
        name: e.name,
        label: e.label,
        value: e.value,
      })
      setEditPO((prev) => ({
        ...prev,
        phone_no: e.phone_no,
      }))
    }
  }

  function handlePOChange(e) {
    const { name, value } = e.target
    setEditPO((prevState) => ({
      ...prevState,
      [name]: value,
    }))
    if (name === "service_fee" || name === "discount") {
      setIsChanged(!isChanged)
    }
  }

  function handleAddressChange(e) {
    setEditPO({ ...editPO, delivery_address: e.target.value })
  }

  async function savePO() {
    var errors = validatePurchaseItems(items)
    setItemError(errors)
    if (
      validateEditPO(editPO, items, setIsError) &&
      Object.keys(errors).length === 0
    ) {
      editPO.is_save = 1
      editPO.status = "pending"
      editPO.attachments = fileList
      editPO.prev_files = prevAttachments
      const response = await updatePurchaseOrder(editPO, items)
      if (response.data) {
        toast.success("Purchase Order Saved Succesfully", {
          style: toastStyle(),
        })
        setTimeout(() => navigate("/purchaseorders"), 1000)
      } else {
        toast.error("Error Saving Purchase Order", {
          style: toastStyle(),
        })
        setTimeout(() => refreshPage(), 1000)
      }
    } else {
      toast.error("Please fill in all fields", {
        style: toastStyle(),
      })
    }
  }

  async function submitPO() {
    var errors = validatePurchaseItems(items)
    setItemError(errors)

    if (
      validateEditPO(editPO, items, setIsError) &&
      Object.keys(errors).length === 0
    ) {
      editPO.is_save = 0
      editPO.status = "for approval"
      editPO.attachments = fileList
      editPO.prev_files = prevAttachments
      const response = await updatePurchaseOrder(editPO, items)
      if (response.status === 200) {
        toast.success("Purchase Order Updated Succesfully", {
          style: toastStyle(),
        })
        setTimeout(() => navigate("/purchaseorders"), 1000)
      } else {
        toast.error("Error Updating Purchase Order", {
          style: toastStyle(),
        })
      }
    } else {
      toast.error("Please fill in all fields", {
        style: toastStyle(),
      })
    }
  }

  function handleRemoveItem(id) {
    setIsChanged(true)

    const rowId = id
    const newItemList = [...items]
    newItemList.splice(rowId, 1)
    setItems(newItemList)

    const filteredOptions = itemsOptions.filter((option) => {
      return !newItemList.find((item) => item.value === option.value)
    })
    setFilteredItemOptions(filteredOptions)

    editPO.grand_total = newItemList
      .map((item) => item.amount)
      .reduce((a, b) => a + b, 0)

    setTimeout(() => setIsChanged(false), 1)
  }

  function AddItem() {
    const newItem = {
      id: "",
      ingredient_id: "",
      qty: 1,
      unit: "",
      price: 0,
      amount: 0,
      discount_amount: 0,
      discount_percentage: 0,
      subtotal: 0,
    }
    setItems((prevItems) => [...prevItems, newItem])
  }

  // PO ORDER ITEMS CHANGE
  function handleItemChange(e, id, search) {
    setIsChanged(true)

    if (search) {
      var item_name = itemsOptions.filter((data) => {
        return data.value === e //e is the id of the item selected we need to find the item name so that we can set it in the item_id_value
      })
      const list = [...items]
      list[id].item_id = e
      list[id].item_id_value = {
        label: item_name[0].label,
        value: item_name[0].value,
      }

      if (
        parseInt(item_name[0]?.item_units[0]?.current_qty) <
        parseInt(item_name[0]?.item_units[0]?.max)
      ) {
        list[id]["qty"] =
          item_name[0]?.item_units[0]?.max -
          item_name[0]?.item_units[0]?.current_qty
      } else if (
        parseInt(item_name[0]?.item_units[0]?.current_qty) >=
        parseInt(item_name[0]?.item_units[0]?.max)
      ) {
        list[id]["qty"] = parseInt(item_name[0]?.item_units[0]?.max)
      } else {
        list[id]["qty"] = 1
      }

      list[id]["unit"] = item_name[0]?.item_units[0]?.unit_to
      list[id]["current_qty"] = item_name[0]?.item_units[0]?.current_qty
      list[id]["price"] =
        item_name[0]?.item_units[0]?.previous_item_price || "0"
      list[id]["amount"] =
        parseFloat(list[id]["qty"] ? list[id]["qty"] : 0) *
        parseFloat(list[id]["price"] ? list[id]["price"] : 0)
      list[id]["subtotal"] =
        parseFloat(list[id]["qty"] ? list[id]["qty"] : 0) *
        parseFloat(list[id]["price"] ? list[id]["price"] : 0)
      // itemsList?.map((data) => {
      //   data.item_units.map((info) => {
      //     if (e.value === info.item_id) {
      //       if (parseInt(info.current_qty) < parseInt(info.max)) {
      //         list[id]["qty"] = info.max - info.current_qty;
      //       } else {
      //         list[id]["qty"] = parseInt(info.max);
      //       }

      //       list[id]["unit"] = info.unit_to;
      //       list[id]["current_qty"] = info.current_qty;
      //       list[id]["price"] =
      //         info.price === null || info.price === "0"
      //           ? info.previous_item_price
      //           : info.price;
      //       list[id]["amount"] =
      //         parseFloat(list[id]["qty"] ? list[id]["qty"] : 0) *
      //         parseFloat(list[id]["price"] ? list[id]["price"] : 0);
      //       list[id]["subtotal"] =
      //         parseFloat(list[id]["qty"] ? list[id]["qty"] : 0) *
      //         parseFloat(list[id]["price"] ? list[id]["price"] : 0);
      //     }
      //   });
      // });
      setItems(list)
    } else {
      const { name, value } = e.target
      const list = [...items]

      if (
        name === "qty" ||
        name === "price" ||
        name === "discount_percentage"
      ) {
        items.map((item, index) => {
          if (index === id) {
            item[name] = value

            var tempTotal = item.qty * item.price
            var totalDiscount = tempTotal * (item.discount_percentage / 100)
            item.subtotal = parseFloat(tempTotal)
            item.amount = parseFloat(tempTotal - totalDiscount)
            item.discount_amount = parseFloat(totalDiscount)
          }
        })
        editPO.grand_total = items
          .map((item) => parseFloat(item.amount))
          .reduce((a, b) => a + b, 0)
      } else {
        items.map((item, index) => {
          if (index === id) {
            item[name] = value
          }
        })

        editPO.grand_total = items
          .map((item) => parseFloat(item.amount))
          .reduce((a, b) => a + b, 0)
      }
      setTimeout(() => setIsChanged(false), 1)
    }
  }

  // ITEM CONVERSION CHANGE
  function handleConversionChange(e, id) {
    const { name, value } = e.target
    var newItemsUnits = itemsUnits
    if (name === "unit_from") {
      var newBreakdownUnit = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.unit_from = value
        }
        return item
      })
      setItemsUnits(newBreakdownUnit)
    } else if (name === "value_from") {
      var newBreakdownValue = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.value_from = value
        }
        return item
      })
      setItemsUnits(newBreakdownValue)
    } else if (name === "unit_to") {
      var newInventoryUnit = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.unit_to = value
        }
        return item
      })
      setItemsUnits(newInventoryUnit)
    } else if (name === "value_to") {
      var newInventoryValue = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.value_to = value
        }
        return item
      })
      setItemsUnits(newInventoryValue)
    } else if (name === "minimum") {
      var newMinimum = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.minimum = value
        }
        return item
      })
      setItemsUnits(newMinimum)
    } else if (name === "maximum") {
      var newMaximum = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.maximum = value
        }
        return item
      })
      setItemsUnits(newMaximum)
    } else if (name === "acceptable_variance") {
      var newAcceptableVatriance = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.acceptable_variance = value
        }
        return item
      })
      setItemsUnits(newAcceptableVatriance)
    }
  }

  function handleClickImageThumbnail(index) {
    handleShowAttachmentsModal()
    setStartAt(index)
  }

  function renderTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Current Quantity</th>
            <th>Unit</th>
            <th>Unit Price</th>
            <th>Discount (%)</th>
            {/* <th>Discount Amt</th> */}
            <th>Amount</th>
            <th>Remarks</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={item.id}>
                <td>
                  <div>
                    <Form.Control
                      type="text"
                      name="description"
                      className="nc-modal-custom-input mb-1 w-full"
                      value={item.description}
                      onChange={(e) => handleItemChange(e, index, false)}
                      placeholder="Description"
                      wrap="true"
                      // disabled
                    />
                    {itemError[index] && itemError[index].description && (
                      <div className="validity-error callout bottom">
                        {itemError[index].description}
                      </div>
                    )}
                  </div>
                  <div className="d-flex justify-content-start align-items-start">
                    <SearchBox
                      showSearch
                      value={item.item_id_value}
                      placeholder={"Search Item..."}
                      className="react-select-container w-full"
                      dropdownClassName="z-large antdesign-custom-dropdown"
                      style={{
                        ...antdesignSelectStyle,
                        whiteSpace: "normal", // Allow text to wrap onto a new line
                        wordWrap: "break-word", // Break long words and wrap onto a new line
                      }}
                      defaultActiveFirstOption={false}
                      suffixIcon={null}
                      filterOption={false}
                      onSearch={handleSearch}
                      onChange={(e) => handleItemChange(e, index, true)}
                      notFoundContent={null}
                      options={(itemsOptions || []).map((d) => ({
                        value: d.value,
                        label: d.label,
                      }))}
                    />
                  </div>

                  {/* <Select
                    options={filteredItemOptions}
                    value={item.item_id_value}
                    name="item_id"
                    placeholder="Choose item"
                    onChange={(e) => handleItemChange(e, index, true)}
                    search={true}
                  /> */}
                </td>
                <td>
                  <Form.Control
                    type="number"
                    min="1"
                    name="qty"
                    className="nc-modal-custom-input hide-spinner numeric-input"
                    value={item.qty}
                    onChange={(e) => handleItemChange(e, index, false)}
                  />
                  {itemError[index] && itemError[index].qty && (
                    <div className="validity-error callout bottom">
                      {itemError[index].qty}
                    </div>
                  )}
                </td>
                <td>
                  <Form.Control
                    type="text"
                    name="current"
                    value={numberWithCommas(item.current_qty)}
                    // onChange={(e) => handleItemChange(e, index, false)}
                    disabled
                  />
                </td>
                <td>
                  {item.item_id_value?.value === null ||
                  item.item_id_value?.value === "" ||
                  item.item_id_value?.is_old_item ? (
                    <Form.Control
                      type="text"
                      name="unit"
                      value={item.unit}
                      onChange={(e) => handleItemChange(e, index, false)}
                    />
                  ) : (
                    <Form.Select
                      name="unit"
                      id={item.id}
                      value={item.unit}
                      onChange={(e) => handleItemChange(e, index, false)}
                    >
                      <option value="">Select</option>
                      {itemsOptions
                        ?.filter(
                          (info) =>
                            info.value === item.item_id ||
                            info.value === item.item_id?.value
                        )
                        .map((data) => {
                          return data.item_units.map((info) => {
                            return (
                              <option value={info.unit_to}>
                                {info.unit_to}
                              </option>
                            )
                          })
                        })}
                    </Form.Select>
                  )}
                  {itemError[index] && itemError[index].unit && (
                    <div className="validity-error callout bottom">
                      {itemError[index].unit}
                    </div>
                  )}
                </td>
                <td className="mt-3 row align-contents">
                  <Col xs={2} className="align-middle">
                    PHP
                  </Col>
                  <Col>
                    <Form.Control
                      type="number"
                      name="price"
                      className="hide-spinner numeric-input"
                      value={item.price}
                      onChange={(e) => handleItemChange(e, index, false)}
                    />
                    {itemError[index] && itemError[index].price && (
                      <div className="validity-error callout bottom">
                        {itemError[index].price}
                      </div>
                    )}
                  </Col>
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="discount_percentage"
                    className="hide-spinner numeric-input mb-1"
                    value={item.discount_percentage}
                    onChange={(e) => handleItemChange(e, index, false)}
                  />
                  <Form.Control
                    disabled
                    type="number"
                    name="discount_amount"
                    className="hide-spinner numeric-input"
                    value={parseFloat(item.discount_amount)}
                    onChange={(e) => handleItemChange(e, index, false)}
                  />
                </td>
                <td>PHP {numberFormat(item.amount)}</td>
                <td>
                  <Form.Control
                    type="text"
                    name="remarks"
                    value={item.remarks}
                    onChange={(e) => handleItemChange(e, index, false)}
                  />
                </td>
                <td>
                  <img
                    src={trash}
                    onClick={() => handleRemoveItem(index)}
                    className="cursor-pointer"
                    alt=""
                  />
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  // ADD CONVERSION TABLE
  function renderTableConversion() {
    return (
      <Table>
        <thead>
          <tr>
            <th>
              VALUE 1 - Warehouse Unit<span className="required">*</span>
            </th>
            <th> </th>
            <th>
              VALUE 2 - Store Unit<span className="required">*</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {itemsUnits.map((item, index) => {
            return (
              <tr>
                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_to"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleConversionChange(e, index)}
                      // disabled
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_to"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleConversionChange(e, index)}
                      // disabled
                    />
                  </Col>
                </td>

                <td>
                  <img src={equal} className="cursor-pointer" alt="equal to" />
                </td>

                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_from"
                      className="nc-modal-custom-input hide-spinner numeric-input"
                      onChange={(e) => handleConversionChange(e, index)}
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_from"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleConversionChange(e, index)}
                    />
                  </Col>
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={8}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              EDIT PURCHASE ORDER{" "}
            </h1>
          </Col>
        </Row>

        {/* content */}
        <div className="edit-form">
          <Row>
            <Col xs={12} lg={4}>
              <span className="edit-label">
                Supplier Name <label className="badge-required">{` *`}</label>
              </span>
              <SearchBox
                showSearch
                value={editPO.supplier_id_value}
                placeholder={"Search Supplier..."}
                className="react-select-container w-100"
                dropdownClassName="z-large antdesign-custom-dropdown"
                style={antdesignSelectStyle}
                defaultActiveFirstOption={false}
                suffixIcon={null}
                filterOption={false}
                onSearch={handleSearchSupplier}
                onChange={(e) => handleSelectChange(e, "supplier_id")}
                notFoundContent={null}
                options={(suppliers || []).map((d) => ({
                  value: d.value,
                  label: d.label,
                }))}
              />
              {/* <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Supplier..."
                value={suppliersValue}
                options={suppliers}
                onChange={(e) => handleSelectChange(e)}
              /> */}
              <InputError
                isValid={isError.supplierName}
                message={"Supplier Name is required"}
              />
              <div className="d-flex justify-content-end">
                <span className="edit-label" style={{ color: "#df1227" }}>
                  Supplier Not Found?{" "}
                  <a
                    onClick={handleAddSupplierClick}
                    className="add-supplier-label"
                  >
                    add supplier
                  </a>
                </span>
              </div>
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">
                Purchase Date <label className="badge-required">{` *`}</label>
              </span>
              <Form.Control
                type="date"
                name="purchase_date"
                className="nc-modal-custom-text"
                value={editPO.purchase_date}
                onChange={(e) => handlePOChange(e)}
                // max={today}
              />
              <InputError
                isValid={isError.purchase_date}
                message={"Purchase date is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">
                Delivery Date <label className="badge-required">{` *`}</label>
              </span>
              <Form.Control
                type="date"
                name="delivery_date"
                className="nc-modal-custom-text"
                value={editPO.delivery_date}
                onChange={(e) => handlePOChange(e)}
              />
              <InputError
                isValid={isError.delivery_date}
                message={"delivery date is required"}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} lg={6} className="mt-4 mt-lg-0">
              <span className="edit-label">Contact Name</span>
              <Form.Control
                type="text"
                name="contact_name"
                value={editPO.contact_name}
                onChange={(e) => handlePOChange(e)}
                className="nc-modal-custom-input"
              />
            </Col>
            <Col xs={12} lg={6} className="mt-4 mt-lg-0">
              <span className="edit-label">Contact No.</span>
              <Form.Control
                type="text"
                name="contact_no"
                value={editPO.contact_no}
                onChange={(e) => handlePOChange(e)}
                className="nc-modal-custom-input"
              />
            </Col>
          </Row>

          <Row className="mt-4 mb-2">
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">
                Branch
                <label className="badge-required">{` *`}</label>
              </span>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Branch..."
                value={branchValue}
                options={branchList}
                onChange={(e) => handleSelectChange(e)}
              />
              <InputError
                isValid={isError.branchId}
                message={"Branch is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">Forwarder</span>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Forwarder..."
                value={forwardersValue}
                options={forwarders}
                onChange={(e) => handleSelectChange(e)}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">Forwarder Contact No.</span>
              <Form.Control
                type="text"
                name="forwarder_contact_person"
                className="nc-modal-custom-input"
                value={editPO.phone_no || ""}
                options={forwarders}
                onChange={(e) => handleSelectChange(e, "forwarder_id")}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} lg={6} className="mt-4 mt-lg-0">
              <span className="edit-label">
                Delivery Address
                <label className="badge-required">{` *`}</label>
              </span>
              <Form.Control
                type="text"
                name="delivery_address"
                className="nc-modal-custom-input"
                value={editPO.delivery_address}
                onChange={handleAddressChange}
              />
              <InputError
                isValid={isError.delivery_address}
                message={"Delivery Address is required"}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-4 mt-lg-0">
              <span className="edit-label">
                Requested by <label className="badge-required">{` *`}</label>
              </span>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Forwarder..."
                value={editPO.requisitioner}
                options={employees}
                onChange={(e) => handleSelectChange(e, "requisitioner")}
              />
              <InputError
                isValid={isError.requisitioner}
                message={"requisitioner is required"}
              />
            </Col>
          </Row>
          <Row className="mt-4 pt-3">
            <Col>
              <span className="edit-label mb-2">
                Purchased Items
                <label className="badge-required">{` *`}</label>
              </span>
              <div className="edit-purchased-items">
                {items.length === 0 ? (
                  <span>No Purchased Item Found!</span>
                ) : (
                  renderTable()
                )}
              </div>
              <div className="d-flex justify-content-end">
                <span className="edit-label" style={{ color: "#df1227" }}>
                  Item Not Found?{" "}
                  <a onClick={handleAddItem} className="add-supplier-label">
                    add item
                  </a>
                </span>
              </div>
            </Col>
          </Row>
          <Row className="pt-3 PO-add-item">
            <Col>
              <Button type="button" onClick={() => AddItem()}>
                Add Item
              </Button>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col>
              <span className="edit-label">
                Remarks
                <span className="edit-optional px-2">(Optional)</span>
              </span>
              <Form.Control
                as="textarea"
                name="remarks"
                className="nc-modal-custom-input"
                value={editPO.remarks}
                onChange={(e) => handlePOChange(e)}
              />
            </Col>
          </Row>
          <div className="mt-4 mx-3">
            <div className="mx-1 review-data mb-2">FILE ATTACHMENTS</div>
            <div className="d-flex flex-row gap-2 overflow-auto">
              {prevAttachments &&
                prevAttachments.map((attachment, index) => (
                  <div key={index} className="thumbnail-cont">
                    <img
                      src={attachment.file_url}
                      className="image-thumbnail mt-2"
                      alt=""
                      onClick={() => handleClickImageThumbnail(index)}
                    />
                    <HighlightOffIcon
                      className="delete-icon"
                      onClick={() => handleRemoveItemAttachment(index)}
                    />
                  </div>
                ))}
              {!prevAttachments ||
                (prevAttachments.length === 0 && (
                  <div xs={1}>
                    <div className="no-data-cont d-flex justify-content-left preview-container">
                      <img
                        src={noDataImg}
                        alt="no data found"
                        className="img-preview"
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <Row className="mt-4 mb-2">
            <Col>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>

          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Subtotal</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {numberFormat(editPO.subtotal)}
              </span>
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">
                Delivery/Service Fee
              </span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3}>
              <Form.Control
                type="number"
                name="service_fee"
                value={editPO.service_fee}
                min={0}
                step="0.01"
                className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handlePOChange(e)}
              />
            </Col>
          </Row>

          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Discount</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3}>
              <Form.Control
                type="number"
                name="discount"
                value={editPO.discount}
                min={0}
                step="0.01"
                className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handlePOChange(e)}
              />
            </Col>
          </Row>

          <Row className="align-right py-5">
            <Col xs={6} lg={8} className="text-end">
              <span className="edit-label color-gray grand-total-text">
                Grand Total
              </span>
            </Col>
            <Col xs={6} lg={4} className="text-end">
              <span className="edit-label align-middle grand-total-text">
                {"PHP " + numberFormat(editPO.grand_total)}
              </span>
            </Col>
          </Row>
          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-2"
              onClick={() => navigate("/purchaseorders")}
            >
              Close
            </button>
            {type !== "for_approval" && (
              <button
                type="button"
                className="button-tertiary me-2"
                onClick={() => savePO()}
              >
                Save
              </button>
            )}
            <button
              type="button"
              className="button-primary"
              onClick={() => submitPO()}
            >
              {type === "for_approval" ? "Save" : "Submit"}
            </button>
          </div>
        </div>
      </div>

      <AddModal
        title="SUPPLIER"
        show={showAddSupplierModal}
        onHide={handleCloseAddSupplierModal}
        onSave={handleSaveSupplier}
      >
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              BIR NAME <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="bir_name"
                value={supplierDetails.bir_name}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
              <InputError
                isValid={isError.bir_name}
                message={"BIR name is required"}
              />
            </Col>
            <Col>
              TRADE NAME <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="trade_name"
                value={supplierDetails.trade_name}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
              <InputError
                isValid={isError.trade_name}
                message={"Trade name is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              BIR-REGISTERED ADDRESS
              <Form.Control
                type="text"
                name="bir_address"
                value={supplierDetails.bir_address}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Col>
            <Col>
              TRADE ADDRESS <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="trade_address"
                value={supplierDetails.trade_address}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
              <InputError
                isValid={isError.trade_address}
                message={"Trade address is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              TIN NUMBER <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="tin"
                value={supplierDetails.tin}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
              <InputError isValid={isError.tin} message={"Tin is required"} />
            </Col>
            <Col>
              BIR NUMBER
              <Form.Control
                type="text"
                name="bir_number"
                className="nc-modal-custom-input"
                value={supplierDetails.bir_number}
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Col>
            <Col xl={3}>
              TERM (DAYS)
              <Form.Control
                type="text"
                name="terms"
                value={supplierDetails.terms}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xl={4}>
              CONTACT PERSON <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="contact_person"
                value={supplierDetails.contact_person}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
              <InputError
                isValid={isError.contact_person}
                message={"Contact Person is required"}
              />
            </Col>
            <Col xl={4}>
              PHONE NUMBER <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="phone_no"
                value={supplierDetails.phone_no}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
              <InputError
                isValid={isError.phone_no}
                message={"Phone number is required"}
              />
            </Col>
            <Col>
              PAYEE <label className="badge-required">{` *`}</label>
              <Form.Control
                type="email"
                name="payee"
                value={supplierDetails.payee}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
              <InputError
                isValid={isError.payee}
                message={"Payee is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              PRIMARY BANK NAME
              <Form.Control
                type="text"
                name="bank_primary"
                value={supplierDetails.bank_primary}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              PRIMARY ACCOUNT NO.
              <Form.Control
                type="number"
                name="primary_account_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                required
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Col>
            <Col xl={5}>
              PRIMARY ACCOUNT NAME
              <Form.Control
                type="text"
                name="primary_account_name"
                className="nc-modal-custom-input"
                required
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              ALTERNATE BANK NAME
              <Form.Control
                type="text"
                name="bank_alternate"
                value={supplierDetails.bank_alternate}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              ALTERNATE ACCOUNT NO.
              <Form.Control
                type="number"
                name="alternate_account_no"
                className="nc-modal-custom-input"
                required
                value={supplierDetails.alternate_account_no}
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Col>
            <Col xl={5}>
              ALTERNATE ACCOUNT NAME
              <Form.Control
                type="text"
                name="alternate_account_name"
                className="nc-modal-custom-input"
                value={supplierDetails.alternate_account_name}
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xl={4}>
              COMPANY EMAIL
              <Form.Control
                type="email"
                name="email"
                value={supplierDetails.email}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="m-divider mt-3 mb-3"></Row>
          <Row className="nc-modal-custom-row">
            <Col>
              REQUIREMENTS
              <Form.Control
                type="file"
                multiple
                name="requirements"
                className="nc-modal-custom-input"
                required
              />
            </Col>
          </Row>
        </div>
      </AddModal>

      {/* ADD ITEM MODAL */}
      <AddModal
        title={`ITEM`}
        type="item"
        show={showAddItemModal}
        onHide={handleCloseAddItemModal}
        onSave={handleSaveItem}
        isClicked={isClicked}
      >
        <div className=" mt-3">
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-3">
              ITEM DESCRIPTION
            </span>
            <Col>
              ITEM NAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isErrorItem.name}
                message={"Item name is required"}
              />
            </Col>
            <Col>
              BRAND
              <Typeahead
                id="basic-typeahead-single"
                name="value"
                labelKey="value"
                allowNew
                className="nc-modal-custom-text"
                onChange={(e) => handleTypeaheadChange(e, "brand")}
                options={brand}
                placeholder="Select/type a brand..."
                selected={itemDetails.selected_brand}
              />
            </Col>
            <Col>
              MODEL
              <Form.Control
                type="text"
                name="model"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col>
              MATERIAL
              <Form.Control
                type="text"
                name="material"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col>
              COLOR
              <Form.Control
                type="text"
                name="color"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col>
              SIZE
              <Form.Control
                type="text"
                name="size"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <span className="custom-modal-body-title-employee mb-3">
              ITEM DETAILS
            </span>
            <Col>
              BARCODE
              <Form.Control
                type="text"
                name="barcode"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col>
              INHOUSE BARCODE
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="inhouse_barcode"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isErrorItem.inhouse_barcode}
                message={"Inhouse barcode is required"}
              />
            </Col>
            <Col>
              SERIAL NUMBER
              <Form.Control
                type="text"
                name="serial_number"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col>
              TAG
              <Form.Control
                type="text"
                name="tag"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col>
              ITEM CODE
              <Form.Control
                type="text"
                name="tag"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col>
              SALES TYPE
              <span className="required"> * </span>
              <select
                name="sales_type"
                className="ms-0 nc-modal-custom-select nc-modal-custom-input-edit "
                onChange={(e) => handleAddChange(e)}
              >
                <option hidden selected className="nc-modal-custom-select">
                  Select
                </option>
                <option value="wholesale"> Wholesale </option>
                <option value="retail"> Retail </option>
                <option value="universal"> Both </option>
              </select>
              <InputError
                isValid={isErrorItem.sales_type}
                message={"Sales type is required"}
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <span className="custom-modal-body-title-employee mb-3">
              ITEM CATEGORY
            </span>
            {itemDetails?.category?.map((data, index) => {
              return (
                <Col xs={3}>
                  {index === 0 ? "CATEGORY" : "SUB-CATEGORY"}
                  <Row className="align-middle">
                    <Col xs={10}>
                      <Select
                        name="subcategories"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select..."
                        value={data}
                        options={
                          index === 0
                            ? categories
                            : itemDetails.category_options[index]
                        }
                        // options={filteredSubCategories}
                        onChange={(e) =>
                          handleSelectDropdownChange(e, "add", index)
                        }
                      />
                      <InputError
                        isValid={isError.category}
                        message={"Category is required"}
                      />
                    </Col>
                    {index !== 0 && (
                      <Col xs={2}>
                        <img
                          src={trash}
                          alt="delete"
                          onClick={() => handleRemoveSubcategory(index, "add")}
                          className="cursor-pointer mt-2"
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
              )
            })}
          </Row>
          <Row></Row>
        </div>
      </AddModal>
      {/* ADD CONVERSION MODAL */}
      <AddModal
        title={`UNIT OF MEASURE CONVERSION`}
        type="item"
        show={showAddConversionModal}
        onHide={handleCloseAddConversionModal}
        onSave={handleAddConversion}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          <Row className="nc-modal-custom-row mb-0">
            <Col>UNIT OF MEASURE CONVERSION</Col>
          </Row>
          <Row className="nc-modal-custom-row mt-0">
            <div className="edit-purchased-items justify-content-center">
              <div className="not-found mt-0 ">
                {itemsUnits.length === 0 ? (
                  <span> No unit of measure conversion found! </span>
                ) : (
                  renderTableConversion()
                )}
              </div>
            </div>
          </Row>
        </div>
      </AddModal>

      {/* <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <Row className="justify-content-center">
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
          <div className="mt-2 d-flex justify-content-center">
            <img
              src={trash}
              alt="trash"
              onClick={() => handleRemoveItemAttachment(previewFile)}
              className="cursor-pointer"
            />
          </div>
        </Row>
      </Modal> */}
      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="2MB"
      />
      <AttachmentModal
        show={showAttachmentsModal}
        images={prevAttachments}
        onHide={() => handleCloseAttachmentsModal()}
        selected={startAt}
      />
      <Footer />
    </div>
  )
}
